<template>
    <div class="container-fluid bg-jc m-0 p-0 animated fadeIn slow" style="height: 100vh;">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div class="container px-0 h-100" style="position: relative;">
            <div class="d-flex flex-column h-100">
                <TheHeader class="m-0"/>
                <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'" class="h-100 d-flex justify-content-center mt--5">
                    <div class="align-self-center">
                        <h1 class="text-uppercase font-italic font-weight-bold title">take a look around</h1>
                        <div class="lime-bar-diag">
                            <img src="../assets/img/Asset_3.png" alt="Flouro bar">
                        </div>
                        <div class="sub-title text-uppercase font-xs">Your access is approved.</div>

                        <p class="text-uppercase font-lg option text-left grow mt-5 pt-2">
                            <router-link to="/story">rufus story</router-link>
                        </p>
                        <p class="text-uppercase font-lg option text-left grow">
                            <router-link to="/points-system">universal scoring</router-link>
                        </p>
                        <p class="text-uppercase font-lg option text-left grow">
                            <router-link to="/schedule">full schedule</router-link>
                        </p>
                        <p class="text-uppercase font-lg option text-left grow">
                            <router-link to="/eligibility">undeniable eligibility</router-link>
                        </p>
                        <p v-if="userRole === 'driver' || userRole === 'admin'"
                           class="text-uppercase font-lg option text-left grow">
                            <router-link to="/driver-portal">select driver portal</router-link>
                        </p>
                    </div>

                </div>
                <div v-else class="font-xl font-weight-semi-bold" style="margin-top: 200px;">Sorry, you don't have the
                    correct permissions to access this page...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import firebase from 'firebase'
    import TheHeader from '../components/TheHeader';

    export default {
        name      : 'toc',
        components: {
            TheHeader
        },
        computed  : {
            userAccount () {
                return this.$store.getters.getUserAccount;
            },
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        watch     : {
            userRole (val) {
                if ( val === 'admin' || val === 'driver' || val === 'industry' ) {
                    // console.log('admin or driver...');
                    this.$router.push({path: '/toc'})
                } else {
                    // console.log('not admin or driver');
                    this.$router.push({path: '/login'})
                }
            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .phone {
        a {
            font-size: 30px;
            color: #666666;
            text-decoration: none;
            cursor: default;
        }

        z-index: 1;
        position: relative;
    }

    .text-link-wrapper {
        margin-top: -50px;
        z-index: 1;
        position: relative;
    }

    .text-link {
        color: #666666 !important;
        letter-spacing: 3px;
        margin-left: 180px;
        text-decoration: none;
    }

    .bg-jc {
        background-image: url(../assets/img/PJ-and-Andy.png);
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
    }

    .option {
        letter-spacing: 30px;
        padding-left: 90px;
    }

    .title {
        margin-left: -300px;
    }

    @media all and (max-width: 576px) {
        .option {
            font-size: 12px;
            letter-spacing: 8px;
            padding-left: 12px;
        }

        .title {
            margin-left: -100px;
        }

        .sub-title {
            margin-left: 160px;
        }

        p {
            margin-bottom: 10px;
        }
    }

    @media all and (min-width: 577px) and (max-width: 767px) {
        .option {
            font-size: 16px;
            letter-spacing: 14px;
            padding-left: 12px;
        }

        .title {
            margin-left: -100px;
        }

        .sub-title {
            margin-left: 180px;
        }

        p {
            margin-bottom: 10px;
        }
    }

    @media all and (min-width: 768px) and (max-width: 991px) {
        .option {
            font-size: 18px;
            letter-spacing: 18px;
            padding-left: 12px;
        }

        .title {
            padding-left: -120px;
        }

        .sub-title {
            margin-left: 200px;
        }

        p {
            margin-bottom: 14px;
        }
    }

    @media all and (min-width: 992px) and (max-width: 1199px) {
        .title {
            margin-left: -140px;
        }

        .sub-title {
            margin-left: 200px;
        }
    }

    @media all and (min-width: 1200px) {

        .title {
            margin-left: -160px;
        }

        .sub-title {
            margin-left: 220px;
        }
    }
</style>
